
import React from "react";
import { Table } from "antd";

function ByDeadline({ data }) {
  const columns = [
      {
    title: "SI No",
    key: "siNo",
    render: (_, __, index) => index + 1,
  },
    { title: "Task Name", dataIndex: "task", key: "task" },
    { title: "Description", dataIndex: "description", key: "description" },
    { title: "Priority", dataIndex: "priority", key: "priority" },
    { title: "Status", dataIndex: "status", key: "status" },
    { title: "Employees", dataIndex: "employees", key: "employees" },
    { title: "Due Date", dataIndex: "dueDate", key: "dueDate" },
    { title: "Urgency", dataIndex: "urgency", key: "urgency" },
  ];

 
  const sortedData = [...data].sort(
    (a, b) => new Date(a.dueDate) - new Date(b.dueDate)
  );

  return (
    <Table
      columns={columns}
      dataSource={sortedData}
      pagination={false}
    
    />
  );
}

export default ByDeadline;


